module.exports = __webpack_public_path__ + "static/img/12.22da9b82.png";